
export class ResidentInvoicesSearchArgument {
    public billing_month: number;
    public billing_year: number;    
}